import React from 'react';
interface QuotationHeaderProps {
  company: {
    name: string;
    address: string[];
    phone: string;
    email: string;
    uen: string;
  };
  quotation: {
    number: string;
    date: string;
    validUntil: string;
    currency: string;
    bookingReference: string;
    salesOwner: string;
  };
}
export function QuotationHeader({
  company,
  quotation
}: QuotationHeaderProps) {
  return <>
      {/* Top Row: Logo Left, Address Right */}
      <div className="flex justify-between items-start mb-4" data-id="element-927">
        {/* Left: Logo */}
        <div data-id="element-928">
          <div className="w-14 h-14 bg-gradient-to-br from-blue-600 to-blue-700 rounded-lg flex items-center justify-center shadow-md" data-id="element-929">
            <span className="text-white font-bold text-lg" data-id="element-930">MT</span>
          </div>
        </div>

        {/* Right: Company Address - Compact */}
        <div className="text-right" data-id="element-931">
          <h1 className="text-sm text-neutral-900 mb-1" data-id="element-932">{company.name}</h1>
          <div className="text-[10px] text-neutral-500 space-y-0.5 leading-relaxed" data-id="element-933">
            {company.address.map((line, i) => <p key={i} data-id="element-934">{line}</p>)}
            <p className="mt-1" data-id="element-935">
              Tel: {company.phone} | Email: {company.email}
            </p>
            <p data-id="element-936">UEN: {company.uen}</p>
          </div>
        </div>
      </div>

      {/* QUOTATION Title - Centered Above Box */}
      <h2 className="text-lg font-bold text-neutral-900 mb-2 tracking-tight text-center" data-id="element-937">
        CUSTOMIZED TOUR QUOTATION
      </h2>

      {/* Quotation Details Box */}
      <div className="bg-neutral-50 border border-neutral-200 rounded-lg p-3 mb-4" data-id="element-938">
        {/* Two Column Grid */}
        <div className="grid grid-cols-2 gap-x-8 gap-y-1.5" data-id="element-939">
          {/* Left Column */}
          <div className="space-y-1.5" data-id="element-940">
            <div className="flex justify-between" data-id="element-941">
              <span className="text-xs font-medium text-neutral-600" data-id="element-942">
                Quote Number:
              </span>
              <span className="text-xs font-semibold text-neutral-900" data-id="element-943">
                {quotation.number}
              </span>
            </div>
            <div className="flex justify-between" data-id="element-944">
              <span className="text-xs font-medium text-neutral-600" data-id="element-945">
                Quote Date:
              </span>
              <span className="text-xs text-neutral-900" data-id="element-946">{quotation.date}</span>
            </div>
            <div className="flex justify-between" data-id="element-947">
              <span className="text-xs font-medium text-neutral-600" data-id="element-948">
                Valid Until:
              </span>
              <span className="text-xs font-semibold text-red-600" data-id="element-949">
                {quotation.validUntil}
              </span>
            </div>
          </div>

          {/* Right Column */}
          <div className="space-y-1.5" data-id="element-950">
            <div className="flex justify-between" data-id="element-951">
              <span className="text-xs font-medium text-neutral-600" data-id="element-952">
                Currency:
              </span>
              <span className="text-xs font-semibold text-neutral-900" data-id="element-953">
                {quotation.currency}
              </span>
            </div>
            <div className="flex justify-between" data-id="element-954">
              <span className="text-xs font-medium text-neutral-600" data-id="element-955">
                Booking Ref:
              </span>
              <span className="text-xs text-neutral-900" data-id="element-956">
                {quotation.bookingReference}
              </span>
            </div>
            <div className="flex justify-between" data-id="element-957">
              <span className="text-xs font-medium text-neutral-600" data-id="element-958">
                Sales Owner:
              </span>
              <span className="text-xs font-semibold text-neutral-900" data-id="element-959">
                {quotation.salesOwner}
              </span>
            </div>
          </div>
        </div>
      </div>
    </>;
}